import { Component } from 'react';
import { connect } from 'react-redux';
import { logout } from '../../actions/login';
import { isPseudoLoggedIn, originalUserIsRepUser } from '../../utils/tokenUtils';

// Preserved across the unmount/remount that happens mid-logout (see below).
// A module-scoped value survives that remount (same runtime) but is discarded
// on the next full page load, so it can never linger as a stale redirect.
let afterLogoutUrl = null;

class Logout extends Component {
  UNSAFE_componentWillMount() {
    const { dispatch } = this.props;

    // Clearing the token below makes App briefly render null (app.jsx guard),
    // which unmounts and remounts this component mid-logout. Skip only that
    // remount — detected by the redirect we already computed — so we don't
    // recompute it once the token is gone (which would default to /) or re-run
    // logout.
    if (afterLogoutUrl !== null) {
      return;
    }

    afterLogoutUrl = this.redirectUrl();

    dispatch({ type: 'CLEAR_PROFILE' });
    dispatch(logout());
  }

  redirectUrl = () => {
    if (!isPseudoLoggedIn()) {
      return '/';
    }
    return originalUserIsRepUser() ? '/team/login' : '/admin/login';
  };

  render() {
    const { processed } = this.props;

    if (processed) {
      window.location.href = afterLogoutUrl || '/admin/login';
    }

    return (
      <p>
        Loggin out...
        {' '}
      </p>
    );
  }
}

export default connect(state => ({
  processed: state.logout.processed,
}))(Logout);
